<template>
  <div class="text-center" v-click-outside="toggleMenu">
    <v-menu offset-y absolute anchor="#userMenu" :value="value" @input="toggleMenu">
      <v-list class="pa0 pt2">
        <slot></slot>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'bh-menu',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleMenu(e) {
      this.$emit('output', e)
    }
  }
}
</script>
